(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[15],{

/***/ "3uBn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Portal; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("7nmT");
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_dom__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_responsive_responsiveContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("/Mt0");
/* harmony import */ var _Portal_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("Yd/I");
/* eslint-env browser */




function Portal(props) {
  var _useContext = Object(react__WEBPACK_IMPORTED_MODULE_0__["useContext"])(_utils_responsive_responsiveContext__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"]),
      isAppMounted = _useContext.isAppMounted;

  if (!isAppMounted) {
    return null;
  }

  var children = props.children,
      _props$name = props.name,
      name = _props$name === void 0 ? _Portal_constants__WEBPACK_IMPORTED_MODULE_3__[/* AFTER_APP */ "b"] : _props$name;
  var htmlElement = document && document.getElementById(name);

  if (!htmlElement) {
    return null;
  }

  return react__WEBPACK_IMPORTED_MODULE_0__["Children"].count(children) ? /*#__PURE__*/react_dom__WEBPACK_IMPORTED_MODULE_1___default.a.createPortal(children, htmlElement) : null;
}

/***/ }),

/***/ "7LZv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return mediumFocus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mediumBlur; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return mediumEffect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return mediumSidecar; });
/* harmony import */ var use_sidecar__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("Ix1X");

var mediumFocus = Object(use_sidecar__WEBPACK_IMPORTED_MODULE_0__[/* createMedium */ "a"])({}, function (_ref) {
  var target = _ref.target,
      currentTarget = _ref.currentTarget;
  return {
    target: target,
    currentTarget: currentTarget
  };
});
var mediumBlur = Object(use_sidecar__WEBPACK_IMPORTED_MODULE_0__[/* createMedium */ "a"])();
var mediumEffect = Object(use_sidecar__WEBPACK_IMPORTED_MODULE_0__[/* createMedium */ "a"])();
var mediumSidecar = Object(use_sidecar__WEBPACK_IMPORTED_MODULE_0__[/* createSidecarMedium */ "b"])({
  async: true
});

/***/ }),

/***/ "D57K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export __extends */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __assign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __rest; });
/* unused harmony export __decorate */
/* unused harmony export __param */
/* unused harmony export __metadata */
/* unused harmony export __awaiter */
/* unused harmony export __generator */
/* unused harmony export __exportStar */
/* unused harmony export __values */
/* unused harmony export __read */
/* unused harmony export __spread */
/* unused harmony export __spreadArrays */
/* unused harmony export __await */
/* unused harmony export __asyncGenerator */
/* unused harmony export __asyncDelegator */
/* unused harmony export __asyncValues */
/* unused harmony export __makeTemplateObject */
/* unused harmony export __importStar */
/* unused harmony export __importDefault */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}


/***/ }),

/***/ "DHMe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BodyLocker; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_layers_stopScroll__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("qVkC");
/* eslint-env browser */


var BodyLocker = function BodyLocker(_ref) {
  var _ref$isLocked = _ref.isLocked,
      isLocked = _ref$isLocked === void 0 ? false : _ref$isLocked,
      children = _ref.children;
  var bodyScrollTop = Object(react__WEBPACK_IMPORTED_MODULE_0__["useRef"])(false);
  Object(react__WEBPACK_IMPORTED_MODULE_0__["useEffect"])(function () {
    if (isLocked) {
      bodyScrollTop.current = Object(_utils_layers_stopScroll__WEBPACK_IMPORTED_MODULE_1__[/* getTopScrollValue */ "a"])(document);
      Object(_utils_layers_stopScroll__WEBPACK_IMPORTED_MODULE_1__[/* lockBodyScroll */ "b"])(document);
    }

    return function () {
      if (bodyScrollTop.current !== false) {
        Object(_utils_layers_stopScroll__WEBPACK_IMPORTED_MODULE_1__[/* resumeBodyScroll */ "c"])(document, bodyScrollTop.current);
      }

      bodyScrollTop.current = false;
    };
  }, [isLocked]);
  return children;
};

/***/ }),

/***/ "Foxp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: /home/circleci/project/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__("D57K");

// EXTERNAL MODULE: /home/circleci/project/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// CONCATENATED MODULE: /home/circleci/project/node_modules/use-sidecar/dist/es2015/exports.js


var SideCar = function (_a) {
    var sideCar = _a.sideCar, rest = tslib_es6["b" /* __rest */](_a, ["sideCar"]);
    if (!sideCar) {
        throw new Error('Sidecar: please provide `sideCar` property to import the right car');
    }
    var Target = sideCar.read();
    if (!Target) {
        throw new Error('Sidecar medium not found');
    }
    return react["createElement"](Target, tslib_es6["a" /* __assign */]({}, rest));
};
SideCar.isSideCarExport = true;
function exportSidecar(medium, exported) {
    medium.useMedium(exported);
    return SideCar;
}

// EXTERNAL MODULE: /home/circleci/project/node_modules/prop-types/index.js
var prop_types = __webpack_require__("aWzz");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/inheritsLoose.js
var inheritsLoose = __webpack_require__("BFfR");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// CONCATENATED MODULE: /home/circleci/project/node_modules/react-clientside-effect/lib/index.es.js




function withSideEffect(reducePropsToState, handleStateChangeOnClient) {
  if (false) {}

  function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
  }

  return function wrap(WrappedComponent) {
    if (false) {}

    var mountedInstances = [];
    var state;

    function emitChange() {
      state = reducePropsToState(mountedInstances.map(function (instance) {
        return instance.props;
      }));
      handleStateChangeOnClient(state);
    }

    var SideEffect =
    /*#__PURE__*/
    function (_PureComponent) {
      Object(inheritsLoose["a" /* default */])(SideEffect, _PureComponent);

      function SideEffect() {
        return _PureComponent.apply(this, arguments) || this;
      }

      // Try to use displayName of wrapped component
      SideEffect.peek = function peek() {
        return state;
      };

      var _proto = SideEffect.prototype;

      _proto.componentDidMount = function componentDidMount() {
        mountedInstances.push(this);
        emitChange();
      };

      _proto.componentDidUpdate = function componentDidUpdate() {
        emitChange();
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        var index = mountedInstances.indexOf(this);
        mountedInstances.splice(index, 1);
        emitChange();
      };

      _proto.render = function render() {
        return react_default.a.createElement(WrappedComponent, this.props);
      };

      return SideEffect;
    }(react["PureComponent"]);

    Object(defineProperty["a" /* default */])(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");

    return SideEffect;
  };
}

/* harmony default export */ var index_es = (withSideEffect);

// CONCATENATED MODULE: /home/circleci/project/node_modules/focus-lock/dist/es2015/utils/array.js
var toArray = function toArray(a) {
  var ret = Array(a.length);
  for (var i = 0; i < a.length; ++i) {
    ret[i] = a[i];
  }
  return ret;
};

var arrayFind = function arrayFind(array, search) {
  return array.filter(function (a) {
    return a === search;
  })[0];
};

var asArray = function asArray(a) {
  return Array.isArray(a) ? a : [a];
};
// EXTERNAL MODULE: /home/circleci/project/node_modules/focus-lock/dist/es2015/constants.js
var constants = __webpack_require__("R6jJ");

// CONCATENATED MODULE: /home/circleci/project/node_modules/focus-lock/dist/es2015/focusIsHidden.js



var focusIsHidden_focusIsHidden = function focusIsHidden() {
  return document && toArray(document.querySelectorAll('[' + constants["a" /* FOCUS_ALLOW */] + ']')).some(function (node) {
    return node.contains(document.activeElement);
  });
};

/* harmony default export */ var es2015_focusIsHidden = (focusIsHidden_focusIsHidden);
// CONCATENATED MODULE: /home/circleci/project/node_modules/focus-lock/dist/es2015/utils/all-affected.js
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };




var filterNested = function filterNested(nodes) {
  var l = nodes.length;
  for (var i = 0; i < l; i += 1) {
    var _loop = function _loop(j) {
      if (i !== j) {
        if (nodes[i].contains(nodes[j])) {
          return {
            v: filterNested(nodes.filter(function (x) {
              return x !== nodes[j];
            }))
          };
        }
      }
    };

    for (var j = 0; j < l; j += 1) {
      var _ret = _loop(j);

      if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
    }
  }
  return nodes;
};

var getTopParent = function getTopParent(node) {
  return node.parentNode ? getTopParent(node.parentNode) : node;
};

var all_affected_getAllAffectedNodes = function getAllAffectedNodes(node) {
  var nodes = asArray(node);
  return nodes.filter(Boolean).reduce(function (acc, currentNode) {
    var group = currentNode.getAttribute(constants["d" /* FOCUS_GROUP */]);
    acc.push.apply(acc, group ? filterNested(toArray(getTopParent(currentNode).querySelectorAll('[' + constants["d" /* FOCUS_GROUP */] + '="' + group + '"]:not([' + constants["c" /* FOCUS_DISABLED */] + '="disabled"])'))) : [currentNode]);
    return acc;
  }, []);
};

/* harmony default export */ var all_affected = (all_affected_getAllAffectedNodes);
// CONCATENATED MODULE: /home/circleci/project/node_modules/focus-lock/dist/es2015/focusInside.js



var focusInFrame = function focusInFrame(frame) {
  return frame === document.activeElement;
};

var focusInside_focusInsideIframe = function focusInsideIframe(topNode) {
  return !!arrayFind(toArray(topNode.querySelectorAll('iframe')), focusInFrame);
};

var focusInside_focusInside = function focusInside(topNode) {
  var activeElement = document && document.activeElement;

  if (!activeElement || activeElement.dataset && activeElement.dataset.focusGuard) {
    return false;
  }
  return all_affected(topNode).reduce(function (result, node) {
    return result || node.contains(activeElement) || focusInside_focusInsideIframe(node);
  }, false);
};

/* harmony default export */ var es2015_focusInside = (focusInside_focusInside);
// CONCATENATED MODULE: /home/circleci/project/node_modules/focus-lock/dist/es2015/utils/tabOrder.js


var tabSort = function tabSort(a, b) {
  var tabDiff = a.tabIndex - b.tabIndex;
  var indexDiff = a.index - b.index;

  if (tabDiff) {
    if (!a.tabIndex) return 1;
    if (!b.tabIndex) return -1;
  }

  return tabDiff || indexDiff;
};

var tabOrder_orderByTabIndex = function orderByTabIndex(nodes, filterNegative, keepGuards) {
  return toArray(nodes).map(function (node, index) {
    return {
      node: node,
      index: index,
      tabIndex: keepGuards && node.tabIndex === -1 ? (node.dataset || {}).focusGuard ? 0 : -1 : node.tabIndex
    };
  }).filter(function (data) {
    return !filterNegative || data.tabIndex >= 0;
  }).sort(tabSort);
};
// CONCATENATED MODULE: /home/circleci/project/node_modules/focus-lock/dist/es2015/utils/tabbables.js
/* harmony default export */ var tabbables = (['button:enabled:not([readonly])', 'select:enabled:not([readonly])', 'textarea:enabled:not([readonly])', 'input:enabled:not([readonly])', 'a[href]', 'area[href]', 'iframe', 'object', 'embed', '[tabindex]', '[contenteditable]', '[autofocus]']);
// CONCATENATED MODULE: /home/circleci/project/node_modules/focus-lock/dist/es2015/utils/tabUtils.js




var queryTabbables = tabbables.join(',');
var queryGuardTabbables = queryTabbables + ', [data-focus-guard]';

var tabUtils_getFocusables = function getFocusables(parents, withGuards) {
  return parents.reduce(function (acc, parent) {
    return acc.concat(
    // add all tabbables inside
    toArray(parent.querySelectorAll(withGuards ? queryGuardTabbables : queryTabbables)),
    // add if node is tabble itself
    parent.parentNode ? toArray(parent.parentNode.querySelectorAll(tabbables.join(','))).filter(function (node) {
      return node === parent;
    }) : []);
  }, []);
};

var tabUtils_getParentAutofocusables = function getParentAutofocusables(parent) {
  var parentFocus = parent.querySelectorAll('[' + constants["b" /* FOCUS_AUTO */] + ']');
  return toArray(parentFocus).map(function (node) {
    return tabUtils_getFocusables([node]);
  }).reduce(function (acc, nodes) {
    return acc.concat(nodes);
  }, []);
};
// CONCATENATED MODULE: /home/circleci/project/node_modules/focus-lock/dist/es2015/utils/DOMutils.js




var isElementHidden = function isElementHidden(computedStyle) {
  if (!computedStyle || !computedStyle.getPropertyValue) {
    return false;
  }
  return computedStyle.getPropertyValue('display') === 'none' || computedStyle.getPropertyValue('visibility') === 'hidden';
};

var isVisible = function isVisible(node) {
  return !node || node === document || node.nodeType === Node.DOCUMENT_NODE || !isElementHidden(window.getComputedStyle(node, null)) && isVisible(node.parentNode);
};

var notHiddenInput = function notHiddenInput(node) {
  return !((node.tagName === 'INPUT' || node.tagName === 'BUTTON') && (node.type === 'hidden' || node.disabled));
};

var getParents = function getParents(node) {
  var parents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  parents.push(node);
  if (node.parentNode) {
    getParents(node.parentNode, parents);
  }
  return parents;
};

var getCommonParent = function getCommonParent(nodea, nodeb) {
  var parentsA = getParents(nodea);
  var parentsB = getParents(nodeb);

  for (var i = 0; i < parentsA.length; i += 1) {
    var currentParent = parentsA[i];
    if (parentsB.indexOf(currentParent) >= 0) {
      return currentParent;
    }
  }
  return false;
};

var DOMutils_filterFocusable = function filterFocusable(nodes) {
  return toArray(nodes).filter(function (node) {
    return isVisible(node);
  }).filter(function (node) {
    return notHiddenInput(node);
  });
};

var DOMutils_getTabbableNodes = function getTabbableNodes(topNodes, withGuards) {
  return tabOrder_orderByTabIndex(DOMutils_filterFocusable(tabUtils_getFocusables(topNodes, withGuards)), true, withGuards);
};

var DOMutils_getAllTabbableNodes = function getAllTabbableNodes(topNodes) {
  return tabOrder_orderByTabIndex(DOMutils_filterFocusable(tabUtils_getFocusables(topNodes)), false);
};

var DOMutils_parentAutofocusables = function parentAutofocusables(topNode) {
  return DOMutils_filterFocusable(tabUtils_getParentAutofocusables(topNode));
};
// CONCATENATED MODULE: /home/circleci/project/node_modules/focus-lock/dist/es2015/utils/firstFocus.js
var isRadio = function isRadio(node) {
  return node.tagName === 'INPUT' && node.type === 'radio';
};

var findSelectedRadio = function findSelectedRadio(node, nodes) {
  return nodes.filter(isRadio).filter(function (el) {
    return el.name === node.name;
  }).filter(function (el) {
    return el.checked;
  })[0] || node;
};

var pickFirstFocus = function pickFirstFocus(nodes) {
  if (nodes[0] && nodes.length > 1) {
    if (isRadio(nodes[0]) && nodes[0].name) {
      return findSelectedRadio(nodes[0], nodes);
    }
  }
  return nodes[0];
};

/* harmony default export */ var utils_firstFocus = (pickFirstFocus);
// CONCATENATED MODULE: /home/circleci/project/node_modules/focus-lock/dist/es2015/focusMerge.js





var findAutoFocused = function findAutoFocused(autoFocusables) {
  return function (node) {
    return !!node.autofocus || node.dataset && !!node.dataset.autofocus || autoFocusables.indexOf(node) >= 0;
  };
};

var isGuard = function isGuard(node) {
  return node.dataset && node.dataset.focusGuard;
};
var notAGuard = function notAGuard(node) {
  return !isGuard(node);
};

var focusMerge_newFocus = function newFocus(innerNodes, outerNodes, activeElement, lastNode, autoFocused) {
  var cnt = innerNodes.length;
  var firstFocus = innerNodes[0];
  var lastFocus = innerNodes[cnt - 1];

  // focus is inside
  if (innerNodes.indexOf(activeElement) >= 0) {
    return undefined;
  }

  var activeIndex = outerNodes.indexOf(activeElement);
  var lastIndex = outerNodes.indexOf(lastNode || activeIndex);
  var lastNodeInside = innerNodes.indexOf(lastNode);
  var indexDiff = activeIndex - lastIndex;
  var firstNodeIndex = outerNodes.indexOf(firstFocus);
  var lastNodeIndex = outerNodes.indexOf(lastFocus);

  // new focus
  if (activeIndex === -1 || lastNodeInside === -1) {
    return innerNodes.indexOf(autoFocused.length ? utils_firstFocus(autoFocused) : utils_firstFocus(innerNodes));
  }
  // old focus
  if (!indexDiff && lastNodeInside >= 0) {
    return lastNodeInside;
  }
  // first element
  if (activeIndex <= firstNodeIndex && isGuard(activeElement) && Math.abs(indexDiff) > 1) {
    return 0;
  }
  // jump out
  if (indexDiff && Math.abs(indexDiff) > 1) {
    return lastNodeInside;
  }
  // focus above lock
  if (activeIndex <= firstNodeIndex) {
    return cnt - 1;
  }
  // focus below lock
  if (activeIndex > lastNodeIndex) {
    return 0;
  }
  // index is inside tab order, but outside Lock
  if (indexDiff) {
    if (Math.abs(indexDiff) > 1) {
      return lastNodeInside;
    }
    return (cnt + lastNodeInside + indexDiff) % cnt;
  }
  // do nothing
  return undefined;
};

var focusMerge_getTopCommonParent = function getTopCommonParent(baseActiveElement, leftEntry, rightEntries) {
  var activeElements = asArray(baseActiveElement);
  var leftEntries = asArray(leftEntry);
  var activeElement = activeElements[0];
  var topCommon = null;
  leftEntries.filter(Boolean).forEach(function (entry) {
    topCommon = getCommonParent(topCommon || entry, entry) || topCommon;
    rightEntries.filter(Boolean).forEach(function (subEntry) {
      var common = getCommonParent(activeElement, subEntry);
      if (common) {
        if (!topCommon || common.contains(topCommon)) {
          topCommon = common;
        } else {
          topCommon = getCommonParent(common, topCommon);
        }
      }
    });
  });
  return topCommon;
};

var focusMerge_allParentAutofocusables = function allParentAutofocusables(entries) {
  return entries.reduce(function (acc, node) {
    return acc.concat(DOMutils_parentAutofocusables(node));
  }, []);
};

var reorderNodes = function reorderNodes(srcNodes, dstNodes) {
  var remap = new Map();
  // no Set(dstNodes) for IE11 :(
  dstNodes.forEach(function (entity) {
    return remap.set(entity.node, entity);
  });
  // remap to dstNodes
  return srcNodes.map(function (node) {
    return remap.get(node);
  }).filter(Boolean);
};

var focusMerge_getFocusabledIn = function getFocusabledIn(topNode) {
  var entries = all_affected(topNode).filter(notAGuard);
  var commonParent = focusMerge_getTopCommonParent(topNode, topNode, entries);
  var outerNodes = DOMutils_getTabbableNodes([commonParent], true);
  var innerElements = DOMutils_getTabbableNodes(entries).filter(function (_ref) {
    var node = _ref.node;
    return notAGuard(node);
  }).map(function (_ref2) {
    var node = _ref2.node;
    return node;
  });

  return outerNodes.map(function (_ref3) {
    var node = _ref3.node,
        index = _ref3.index;
    return {
      node: node,
      index: index,
      lockItem: innerElements.indexOf(node) >= 0,
      guard: isGuard(node)
    };
  });
};

var focusMerge_getFocusMerge = function getFocusMerge(topNode, lastNode) {
  var activeElement = document && document.activeElement;
  var entries = all_affected(topNode).filter(notAGuard);

  var commonParent = focusMerge_getTopCommonParent(activeElement || topNode, topNode, entries);

  var innerElements = DOMutils_getTabbableNodes(entries).filter(function (_ref4) {
    var node = _ref4.node;
    return notAGuard(node);
  });

  if (!innerElements[0]) {
    innerElements = DOMutils_getAllTabbableNodes(entries).filter(function (_ref5) {
      var node = _ref5.node;
      return notAGuard(node);
    });
    if (!innerElements[0]) {
      return undefined;
    }
  }

  var outerNodes = DOMutils_getTabbableNodes([commonParent]).map(function (_ref6) {
    var node = _ref6.node;
    return node;
  });
  var orderedInnerElements = reorderNodes(outerNodes, innerElements);
  var innerNodes = orderedInnerElements.map(function (_ref7) {
    var node = _ref7.node;
    return node;
  });

  var newId = focusMerge_newFocus(innerNodes, outerNodes, activeElement, lastNode, innerNodes.filter(findAutoFocused(focusMerge_allParentAutofocusables(entries))));

  if (newId === undefined) {
    return newId;
  }
  return orderedInnerElements[newId];
};

/* harmony default export */ var focusMerge = (focusMerge_getFocusMerge);
// CONCATENATED MODULE: /home/circleci/project/node_modules/focus-lock/dist/es2015/setFocus.js


var focusOn = function focusOn(target) {
  target.focus();
  if (target.contentWindow) {
    target.contentWindow.focus();
  }
};

var guardCount = 0;
var lockDisabled = false;

/* harmony default export */ var setFocus = (function (topNode, lastNode) {
  var focusable = focusMerge(topNode, lastNode);

  if (lockDisabled) {
    return;
  }

  if (focusable) {
    if (guardCount > 2) {
      // eslint-disable-next-line no-console
      console.error('FocusLock: focus-fighting detected. Only one focus management system could be active. ' + 'See https://github.com/theKashey/focus-lock/#focus-fighting');
      lockDisabled = true;
      setTimeout(function () {
        lockDisabled = false;
      }, 1);
      return;
    }
    guardCount++;
    focusOn(focusable.node);
    guardCount--;
  }
});
// CONCATENATED MODULE: /home/circleci/project/node_modules/focus-lock/dist/es2015/index.js










/* harmony default export */ var es2015 = (setFocus);
// EXTERNAL MODULE: /home/circleci/project/node_modules/react-focus-lock/dist/es2015/util.js
var util = __webpack_require__("s5tn");

// EXTERNAL MODULE: /home/circleci/project/node_modules/react-focus-lock/dist/es2015/medium.js
var medium = __webpack_require__("7LZv");

// CONCATENATED MODULE: /home/circleci/project/node_modules/react-focus-lock/dist/es2015/Trap.js







var focusOnBody = function focusOnBody() {
  return document && document.activeElement === document.body;
};

var Trap_isFreeFocus = function isFreeFocus() {
  return focusOnBody() || es2015_focusIsHidden();
};

var lastActiveTrap = null;
var lastActiveFocus = null;
var lastPortaledElement = null;
var focusWasOutsideWindow = false;

var defaultWhitelist = function defaultWhitelist() {
  return true;
};

var focusWhitelisted = function focusWhitelisted(activeElement) {
  return (lastActiveTrap.whiteList || defaultWhitelist)(activeElement);
};

var recordPortal = function recordPortal(observerNode, portaledElement) {
  lastPortaledElement = {
    observerNode: observerNode,
    portaledElement: portaledElement
  };
};

var focusIsPortaledPair = function focusIsPortaledPair(element) {
  return lastPortaledElement && lastPortaledElement.portaledElement === element;
};

function autoGuard(startIndex, end, step, allNodes) {
  var lastGuard = null;
  var i = startIndex;

  do {
    var item = allNodes[i];

    if (item.guard) {
      if (item.node.dataset.focusAutoGuard) {
        lastGuard = item;
      }
    } else if (item.lockItem) {
      if (i !== startIndex) {
        // we will tab to the next element
        return;
      }

      lastGuard = null;
    } else {
      break;
    }
  } while ((i += step) !== end);

  if (lastGuard) {
    lastGuard.node.tabIndex = 0;
  }
}

var extractRef = function extractRef(ref) {
  return ref && 'current' in ref ? ref.current : ref;
};

var Trap_activateTrap = function activateTrap() {
  var result = false;

  if (lastActiveTrap) {
    var _lastActiveTrap = lastActiveTrap,
        observed = _lastActiveTrap.observed,
        persistentFocus = _lastActiveTrap.persistentFocus,
        autoFocus = _lastActiveTrap.autoFocus,
        shards = _lastActiveTrap.shards;
    var workingNode = observed || lastPortaledElement && lastPortaledElement.portaledElement;
    var activeElement = document && document.activeElement;

    if (workingNode) {
      var workingArea = [workingNode].concat(shards.map(extractRef).filter(Boolean));

      if (!activeElement || focusWhitelisted(activeElement)) {
        if (persistentFocus || focusWasOutsideWindow || !Trap_isFreeFocus() || !lastActiveFocus && autoFocus) {
          if (workingNode && !(es2015_focusInside(workingArea) || focusIsPortaledPair(activeElement, workingNode))) {
            if (document && !lastActiveFocus && activeElement && !autoFocus) {
              activeElement.blur();
              document.body.focus();
            } else {
              result = es2015(workingArea, lastActiveFocus);
              lastPortaledElement = {};
            }
          }

          focusWasOutsideWindow = false;
          lastActiveFocus = document && document.activeElement;
        }
      }

      if (document) {
        var newActiveElement = document && document.activeElement;
        var allNodes = focusMerge_getFocusabledIn(workingArea);
        var focusedItem = allNodes.find(function (_ref) {
          var node = _ref.node;
          return node === newActiveElement;
        });

        if (focusedItem) {
          // remove old focus
          allNodes.filter(function (_ref2) {
            var guard = _ref2.guard,
                node = _ref2.node;
            return guard && node.dataset.focusAutoGuard;
          }).forEach(function (_ref3) {
            var node = _ref3.node;
            return node.removeAttribute('tabIndex');
          });
          var focusedIndex = allNodes.indexOf(focusedItem);
          autoGuard(focusedIndex, allNodes.length, +1, allNodes);
          autoGuard(focusedIndex, -1, -1, allNodes);
        }
      }
    }
  }

  return result;
};

var onTrap = function onTrap(event) {
  if (Trap_activateTrap() && event) {
    // prevent scroll jump
    event.stopPropagation();
    event.preventDefault();
  }
};

var Trap_onBlur = function onBlur() {
  return Object(util["a" /* deferAction */])(Trap_activateTrap);
};

var onFocus = function onFocus(event) {
  // detect portal
  var source = event.target;
  var currentNode = event.currentTarget;

  if (!currentNode.contains(source)) {
    recordPortal(currentNode, source);
  }
};

var FocusWatcher = function FocusWatcher() {
  return null;
};

var Trap_FocusTrap = function FocusTrap(_ref4) {
  var children = _ref4.children;
  return react_default.a.createElement("div", {
    onBlur: Trap_onBlur,
    onFocus: onFocus
  }, children);
};

Trap_FocusTrap.propTypes =  false ? undefined : {};

var onWindowBlur = function onWindowBlur() {
  focusWasOutsideWindow = true;
};

var attachHandler = function attachHandler() {
  document.addEventListener('focusin', onTrap, true);
  document.addEventListener('focusout', Trap_onBlur);
  window.addEventListener('blur', onWindowBlur);
};

var detachHandler = function detachHandler() {
  document.removeEventListener('focusin', onTrap, true);
  document.removeEventListener('focusout', Trap_onBlur);
  window.removeEventListener('blur', onWindowBlur);
};

function Trap_reducePropsToState(propsList) {
  return propsList.filter(function (_ref5) {
    var disabled = _ref5.disabled;
    return !disabled;
  });
}

function Trap_handleStateChangeOnClient(traps) {
  var trap = traps.slice(-1)[0];

  if (trap && !lastActiveTrap) {
    attachHandler();
  }

  var lastTrap = lastActiveTrap;
  var sameTrap = lastTrap && trap && trap.id === lastTrap.id;
  lastActiveTrap = trap;

  if (lastTrap && !sameTrap) {
    lastTrap.onDeactivation(); // return focus only of last trap was removed

    if (!traps.filter(function (_ref6) {
      var id = _ref6.id;
      return id === lastTrap.id;
    }).length) {
      // allow defer is no other trap is awaiting restore
      lastTrap.returnFocus(!trap);
    }
  }

  if (trap) {
    lastActiveFocus = null;

    if (!sameTrap || lastTrap.observed !== trap.observed) {
      trap.onActivation();
    }

    Trap_activateTrap(true);
    Object(util["a" /* deferAction */])(Trap_activateTrap);
  } else {
    detachHandler();
    lastActiveFocus = null;
  }
} // bind medium


medium["c" /* mediumFocus */].assignSyncMedium(onFocus);
medium["a" /* mediumBlur */].assignMedium(Trap_onBlur);
medium["b" /* mediumEffect */].assignMedium(function (cb) {
  return cb({
    moveFocusInside: es2015,
    focusInside: es2015_focusInside
  });
});
/* harmony default export */ var Trap = (index_es(Trap_reducePropsToState, Trap_handleStateChangeOnClient)(FocusWatcher));
// CONCATENATED MODULE: /home/circleci/project/node_modules/react-focus-lock/dist/es2015/sidecar.js



/* harmony default export */ var sidecar = (exportSidecar(medium["d" /* mediumSidecar */], Trap));
// CONCATENATED MODULE: /home/circleci/project/node_modules/react-style-singleton/dist/es2015/singleton.js
function makeStyleTag() {
    if (!document)
        return null;
    var tag = document.createElement('style');
    tag.type = 'text/css';
    return tag;
}
function injectStyles(tag, css) {
    if (tag.styleSheet) {
        tag.styleSheet.cssText = css;
    }
    else {
        tag.appendChild(document.createTextNode(css));
    }
}
function insertStyleTag(tag) {
    var head = document.head || document.getElementsByTagName('head')[0];
    head.appendChild(tag);
}
var stylesheetSingleton = function () {
    var counter = 0;
    var stylesheet = null;
    return {
        add: function (style) {
            if (counter == 0) {
                if (stylesheet = makeStyleTag()) {
                    injectStyles(stylesheet, style);
                    insertStyleTag(stylesheet);
                }
            }
            counter++;
        },
        remove: function () {
            counter--;
            if (!counter && stylesheet) {
                stylesheet.parentNode && stylesheet.parentNode.removeChild(stylesheet);
                stylesheet = null;
            }
        }
    };
};

// CONCATENATED MODULE: /home/circleci/project/node_modules/react-style-singleton/dist/es2015/hook.js


var styleHookSingleton = function () {
    var sheet = stylesheetSingleton();
    return function (styles) {
        react["useEffect"](function () {
            sheet.add(styles);
            return function () {
                sheet.remove();
            };
        }, []);
    };
};

// CONCATENATED MODULE: /home/circleci/project/node_modules/react-style-singleton/dist/es2015/component.js

var styleSingleton = function () {
    var useStyle = styleHookSingleton();
    var Sheet = function (_a) {
        var styles = _a.styles;
        useStyle(styles);
        return null;
    };
    return Sheet;
};

// CONCATENATED MODULE: /home/circleci/project/node_modules/react-style-singleton/dist/es2015/index.js




// CONCATENATED MODULE: /home/circleci/project/node_modules/react-remove-scroll-bar/dist/es2015/utils.js
var zeroGap = {
    left: 0,
    top: 0,
    right: 0,
    gap: 0,
};
var parse = function (x) { return parseInt(x || '', 10) || 0; };
var getOffset = function (gapMode) {
    var cs = window.getComputedStyle(document.body);
    var left = cs[gapMode === 'padding' ? 'paddingLeft' : 'marginLeft'];
    var top = cs[gapMode === 'padding' ? 'paddingTop' : 'marginTop'];
    var right = cs[gapMode === 'padding' ? 'paddingRight' : 'marginRight'];
    return [
        parse(left),
        parse(top),
        parse(right),
    ];
};
var getGapWidth = function (gapMode) {
    if (gapMode === void 0) { gapMode = 'margin'; }
    if (typeof window === 'undefined') {
        return zeroGap;
    }
    var offsets = getOffset(gapMode);
    var documentWidth = document.documentElement.clientWidth;
    var windowWidth = window.innerWidth;
    return {
        left: offsets[0],
        top: offsets[1],
        right: offsets[2],
        gap: Math.max(0, windowWidth - documentWidth + offsets[2] - offsets[0]),
    };
};

// EXTERNAL MODULE: /home/circleci/project/node_modules/react-remove-scroll-bar/dist/es2015/constants.js
var es2015_constants = __webpack_require__("Oi45");

// CONCATENATED MODULE: /home/circleci/project/node_modules/react-remove-scroll-bar/dist/es2015/component.js




var component_Style = styleSingleton();
var getStyles = function (_a, allowRelative, gapMode, important) {
    var left = _a.left, top = _a.top, right = _a.right, gap = _a.gap;
    if (gapMode === void 0) { gapMode = 'margin'; }
    return "\n  ." + es2015_constants["b" /* noScrollbarsClassName */] + " {\n   overflow: hidden " + important + ";\n   padding-right: " + gap + "px " + important + ";\n  }\n  body {\n    overflow: hidden " + important + ";\n    " + [
        allowRelative && "position: relative " + important + ";",
        gapMode === 'margin' && "\n    padding-left: " + left + "px;\n    padding-top: " + top + "px;\n    padding-right: " + right + "px;\n    margin-left:0;\n    margin-top:0;\n    margin-right: " + gap + "px " + important + ";\n    ",
        gapMode === 'padding' && "padding-right: " + gap + "px " + important + ";",
    ].filter(Boolean).join('') + "\n  }\n  \n  ." + es2015_constants["c" /* zeroRightClassName */] + " {\n    right: " + gap + "px " + important + ";\n  }\n  \n  ." + es2015_constants["a" /* fullWidthClassName */] + " {\n    margin-right: " + gap + "px " + important + ";\n  }\n  \n  ." + es2015_constants["c" /* zeroRightClassName */] + " ." + es2015_constants["c" /* zeroRightClassName */] + " {\n    right: 0 " + important + ";\n  }\n  \n  ." + es2015_constants["a" /* fullWidthClassName */] + " ." + es2015_constants["a" /* fullWidthClassName */] + " {\n    margin-right: 0 " + important + ";\n  }\n";
};
var RemoveScrollBar = function (props) {
    var _a = react["useState"](getGapWidth(props.gapMode)), gap = _a[0], setGap = _a[1];
    react["useEffect"](function () {
        setGap(getGapWidth(props.gapMode));
    }, [props.gapMode]);
    var noRelative = props.noRelative, noImportant = props.noImportant, _b = props.gapMode, gapMode = _b === void 0 ? 'margin' : _b;
    return react["createElement"](component_Style, { styles: getStyles(gap, !noRelative, gapMode, !noImportant ? "!important" : '') });
};

// CONCATENATED MODULE: /home/circleci/project/node_modules/react-remove-scroll-bar/dist/es2015/index.js





// CONCATENATED MODULE: /home/circleci/project/node_modules/react-remove-scroll/dist/es2015/handleScroll.js
var elementCouldBeVScrolled = function (node) {
    var styles = window.getComputedStyle(node);
    return (styles.overflowY !== 'hidden' && // not-not-scrollable
        !(styles.overflowY === styles.overflowX && styles.overflowY === 'visible') // scrollable
    );
};
var elementCouldBeHScrolled = function (node) {
    var styles = window.getComputedStyle(node);
    return (styles.overflowX !== 'hidden' && // not-not-scrollable
        !(styles.overflowY === styles.overflowX && styles.overflowX === 'visible') // scrollable
    );
};
var locationCouldBeScrolled = function (axis, node) {
    var current = node;
    do {
        var isScrollable = elementCouldBeScrolled(axis, current);
        if (isScrollable) {
            var _a = getScrollVariables(axis, current), s = _a[1], d = _a[2];
            if (s > d) {
                return true;
            }
        }
        current = current.parentNode;
    } while (current && current !== document.body);
    return false;
};
var getVScrollVariables = function (_a) {
    var scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
    return [scrollTop, scrollHeight, clientHeight];
};
var getHScrollVariables = function (_a) {
    var scrollLeft = _a.scrollLeft, scrollWidth = _a.scrollWidth, clientWidth = _a.clientWidth;
    return [scrollLeft, scrollWidth, clientWidth];
};
var elementCouldBeScrolled = function (axis, node) {
    return axis === 'v' ? elementCouldBeVScrolled(node) : elementCouldBeHScrolled(node);
};
var getScrollVariables = function (axis, node) {
    return axis === 'v' ? getVScrollVariables(node) : getHScrollVariables(node);
};
var handleScroll = function (axis, endTarget, event, sourceDelta, noOverscroll) {
    var delta = sourceDelta;
    // find scrollable target
    var target = event.target;
    var targetInLock = endTarget.contains(target);
    var shouldCancelScroll = false;
    var isDeltaPositive = delta > 0;
    var availableScroll = 0;
    var availableScrollTop = 0;
    do {
        var _a = getScrollVariables(axis, target), position = _a[0], scroll_1 = _a[1], capacity = _a[2];
        var elementScroll = scroll_1 - capacity - position;
        if (position || elementScroll) {
            if (elementCouldBeScrolled(axis, target)) {
                availableScroll += elementScroll;
                availableScrollTop += position;
            }
        }
        target = target.parentNode;
    } while (
    // portaled content
    (!targetInLock && target !== document.body) ||
        // self content
        (targetInLock && (endTarget.contains(target) || endTarget === target)));
    if (0) {}
    else if (isDeltaPositive &&
        ((noOverscroll && availableScroll === 0) ||
            (!noOverscroll && delta > availableScroll))) {
        shouldCancelScroll = true;
    }
    else if (!isDeltaPositive &&
        ((noOverscroll && availableScrollTop === 0) ||
            (!noOverscroll && -delta > availableScrollTop))) {
        shouldCancelScroll = true;
    }
    return shouldCancelScroll;
};

// CONCATENATED MODULE: /home/circleci/project/node_modules/react-remove-scroll/dist/es2015/aggresiveCapture.js
var passiveSupported = false;
if (typeof window !== 'undefined') {
    try {
        var options = Object.defineProperty({}, 'passive', {
            get: function () {
                passiveSupported = true;
                return true;
            }
        });
        window.addEventListener('test', options, options);
        window.removeEventListener('test', options, options);
    }
    catch (err) {
        passiveSupported = false;
    }
}
var nonPassive = passiveSupported ? { passive: false } : false;

// CONCATENATED MODULE: /home/circleci/project/node_modules/react-remove-scroll/dist/es2015/SideEffect.js





var getTouchXY = function (event) {
    return 'changedTouches' in event
        ? [event.changedTouches[0].clientX, event.changedTouches[0].clientY]
        : [0, 0];
};
var getDeltaXY = function (event) { return [event.deltaX, event.deltaY]; };
var SideEffect_extractRef = function (ref) {
    return ref && 'current' in ref ? ref.current : ref;
};
var deltaCompare = function (x, y) {
    return x[0] === y[0] && x[1] === y[1];
};
var generateStyle = function (id) { return "\n  .block-interactivity-" + id + " {pointer-events: none;}\n  .allow-interactivity-" + id + " {pointer-events: all;}\n"; };
var idCounter = 0;
var lockStack = [];
function RemoveScrollSideCar(props) {
    var shouldPreventQueue = react["useRef"]([]);
    var touchStartRef = react["useRef"]([0, 0]);
    var activeAxis = react["useRef"]();
    var id = react["useState"](idCounter++)[0];
    var Style = react["useState"](function () { return styleSingleton(); })[0];
    var lastProps = react["useRef"](props);
    react["useEffect"](function () {
        lastProps.current = props;
    }, [props]);
    react["useEffect"](function () {
        if (props.inert) {
            document.body.classList.add("block-interactivity-" + id);
            var allow_1 = [
                props.lockRef.current
            ].concat((props.shards || []).map(SideEffect_extractRef)).filter(Boolean);
            allow_1.forEach(function (el) { return el.classList.add("allow-interactivity-" + id); });
            return function () {
                document.body.classList.remove("block-interactivity-" + id);
                allow_1.forEach(function (el) {
                    return el.classList.remove("allow-interactivity-" + id);
                });
            };
        }
        return;
    }, [props.inert, props.lockRef.current, props.shards]);
    var shouldCancelEvent = react["useCallback"](function (event, parent) {
        if ('touches' in event && event.touches.length === 2) {
            return !lastProps.current.allowPinchZoom;
        }
        var touch = getTouchXY(event);
        var touchStart = touchStartRef.current;
        var deltaX = 'deltaX' in event ? event.deltaX : touchStart[0] - touch[0];
        var deltaY = 'deltaY' in event ? event.deltaY : touchStart[1] - touch[1];
        var currentAxis;
        var target = event.target;
        var moveDirection = Math.abs(deltaX) > Math.abs(deltaY) ? 'h' : 'v';
        var canBeScrolledInMainDirection = locationCouldBeScrolled(moveDirection, target);
        if (!canBeScrolledInMainDirection) {
            return true;
        }
        if (canBeScrolledInMainDirection) {
            currentAxis = moveDirection;
        }
        else {
            currentAxis = moveDirection === 'v' ? 'h' : 'v';
            canBeScrolledInMainDirection = locationCouldBeScrolled(moveDirection, target);
            // other axis might be not scrollable
        }
        if (!canBeScrolledInMainDirection) {
            return false;
        }
        if (!activeAxis.current &&
            'changedTouches' in event &&
            (deltaX || deltaY)) {
            activeAxis.current = currentAxis;
        }
        if (!currentAxis) {
            return true;
        }
        var cancelingAxis = activeAxis.current || currentAxis;
        return handleScroll(cancelingAxis, parent, event, cancelingAxis == 'h' ? deltaX : deltaY, true);
    }, []);
    var shouldPrevent = react["useCallback"](function (_event) {
        var event = _event;
        if (!lockStack.length || lockStack[lockStack.length - 1] !== Style) {
            // not the last active
            return;
        }
        var delta = 'deltaY' in event ? getDeltaXY(event) : getTouchXY(event);
        var sourceEvent = shouldPreventQueue.current.filter(function (e) {
            return e.name === event.type &&
                e.target === event.target &&
                deltaCompare(e.delta, delta);
        })[0];
        // self event, and should be canceled
        if (sourceEvent && sourceEvent.should) {
            event.preventDefault();
            return;
        }
        // outside or shard event
        if (!sourceEvent) {
            var shardNodes = (lastProps.current.shards || [])
                .map(SideEffect_extractRef)
                .filter(Boolean)
                .filter(function (node) { return node.contains(event.target); });
            var shouldStop = shardNodes.length > 0
                ? shouldCancelEvent(event, shardNodes[0])
                : !lastProps.current.noIsolation;
            if (shouldStop) {
                event.preventDefault();
            }
        }
    }, []);
    var shouldCancel = react["useCallback"](function (name, delta, target, should) {
        var event = { name: name, delta: delta, target: target, should: should };
        shouldPreventQueue.current.push(event);
        setTimeout(function () {
            shouldPreventQueue.current = shouldPreventQueue.current.filter(function (e) { return e !== event; });
        }, 1);
    }, []);
    var scrollTouchStart = react["useCallback"](function (event) {
        touchStartRef.current = getTouchXY(event);
        activeAxis.current = undefined;
    }, []);
    var scrollWheel = react["useCallback"](function (event) {
        shouldCancel(event.type, getDeltaXY(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    var scrollTouchMove = react["useCallback"](function (event) {
        shouldCancel(event.type, getTouchXY(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    react["useEffect"](function () {
        lockStack.push(Style);
        props.setCallbacks({
            onScrollCapture: scrollWheel,
            onWheelCapture: scrollWheel,
            onTouchMoveCapture: scrollTouchMove
        });
        document.addEventListener('wheel', shouldPrevent, nonPassive);
        document.addEventListener('touchmove', shouldPrevent, nonPassive);
        document.addEventListener('touchstart', scrollTouchStart, nonPassive);
        return function () {
            lockStack = lockStack.filter(function (inst) { return inst !== Style; });
            document.removeEventListener('wheel', shouldPrevent, nonPassive);
            document.removeEventListener('touchmove', shouldPrevent, nonPassive);
            document.removeEventListener('touchstart', scrollTouchStart, nonPassive);
        };
    }, []);
    var removeScrollBar = props.removeScrollBar, inert = props.inert;
    return (react["createElement"](react["Fragment"], null,
        inert ? react["createElement"](Style, { styles: generateStyle(id) }) : null,
        removeScrollBar ? react["createElement"](RemoveScrollBar, { gapMode: "margin" }) : null));
}

// EXTERNAL MODULE: /home/circleci/project/node_modules/react-remove-scroll/dist/es2015/medium.js
var es2015_medium = __webpack_require__("StW7");

// CONCATENATED MODULE: /home/circleci/project/node_modules/react-remove-scroll/dist/es2015/sidecar.js



/* harmony default export */ var es2015_sidecar = (exportSidecar(es2015_medium["a" /* effectCar */], RemoveScrollSideCar));

// CONCATENATED MODULE: /home/circleci/project/node_modules/aria-hidden/dist/es2015/index.js
var defaultParent = typeof document !== 'undefined' ? document.body : null;
var counterMap = new WeakMap();
var uncontrolledNodes = new WeakMap();
var markerMap = {};
var lockCount = 0;
var hideOthers = function (originalTarget, parentNode, markerName) {
    if (parentNode === void 0) { parentNode = defaultParent; }
    if (markerName === void 0) { markerName = "data-aria-hidden"; }
    var targets = Array.isArray(originalTarget) ? originalTarget : [originalTarget];
    if (!markerMap[markerName]) {
        markerMap[markerName] = new WeakMap();
    }
    var markerCounter = markerMap[markerName];
    var hiddenNodes = [];
    var deep = function (parent) {
        if (!parent || targets.indexOf(parent) >= 0) {
            return;
        }
        Array.prototype.forEach.call(parent.children, function (node) {
            if (targets.some(function (target) { return node.contains(target); })) {
                deep(node);
            }
            else {
                var attr = node.getAttribute('aria-hidden');
                var alreadyHidden = attr !== null && attr !== 'false';
                var counterValue = (counterMap.get(node) || 0) + 1;
                var markerValue = (markerCounter.get(node) || 0) + 1;
                counterMap.set(node, counterValue);
                markerCounter.set(node, markerValue);
                hiddenNodes.push(node);
                if (counterValue === 1 && alreadyHidden) {
                    uncontrolledNodes.set(node, true);
                }
                if (markerValue === 1) {
                    node.setAttribute(markerName, 'true');
                }
                if (!alreadyHidden) {
                    node.setAttribute('aria-hidden', 'true');
                }
            }
        });
    };
    deep(parentNode);
    lockCount++;
    return function () {
        hiddenNodes.forEach(function (node) {
            var counterValue = counterMap.get(node) - 1;
            var markerValue = markerCounter.get(node) - 1;
            counterMap.set(node, counterValue);
            markerCounter.set(node, markerValue);
            if (!counterValue) {
                if (!uncontrolledNodes.has(node)) {
                    node.removeAttribute('aria-hidden');
                }
                uncontrolledNodes.delete(node);
            }
            if (!markerValue) {
                node.removeAttribute(markerName);
            }
        });
        lockCount--;
        if (!lockCount) {
            counterMap = new WeakMap();
            counterMap = new WeakMap();
            uncontrolledNodes = new WeakMap();
            markerMap = {};
        }
    };
};

// EXTERNAL MODULE: /home/circleci/project/node_modules/react-focus-on/dist/es2015/medium.js
var dist_es2015_medium = __webpack_require__("ZLQb");

// CONCATENATED MODULE: /home/circleci/project/node_modules/react-focus-on/dist/es2015/InteractivityDisabler.js



var InteractivityDisabler_Style = styleSingleton();
var InteractivityDisabler_styles = "\n [" + dist_es2015_medium["b" /* focusHiddenMarker */] + "] {\n   pointer-events: none !important;\n }\n";
var InteractivityDisabler = function () { return react["createElement"](InteractivityDisabler_Style, { styles: InteractivityDisabler_styles }); };

// CONCATENATED MODULE: /home/circleci/project/node_modules/react-focus-on/dist/es2015/Effect.js





var Effect_extractRef = function (ref) {
    return 'current' in ref ? ref.current : ref;
};
function Effect(_a) {
    var setLockProps = _a.setLockProps, onEscapeKey = _a.onEscapeKey, onClickOutside = _a.onClickOutside, shards = _a.shards, onActivation = _a.onActivation, onDeactivation = _a.onDeactivation, noIsolation = _a.noIsolation;
    var _b = Object(react["useState"])(undefined), activeNode = _b[0], setActiveNode = _b[1];
    var lastEventTarget = Object(react["useRef"])(null);
    var mouseTouches = Object(react["useRef"])(0);
    react["useEffect"](function () {
        var onKeyDown = function (event) {
            if (!event.defaultPrevented) {
                if ((event.code === 'Escape' ||
                    event.key === 'Escape' ||
                    event.keyCode === 27) &&
                    onEscapeKey) {
                    onEscapeKey(event);
                }
            }
        };
        var onMouseDown = function (event) {
            if (event.defaultPrevented ||
                event.target === lastEventTarget.current ||
                (event instanceof MouseEvent && event.button !== 0)) {
                return;
            }
            if (shards &&
                shards
                    .map(Effect_extractRef)
                    .some(function (node) {
                    return (node && node.contains(event.target)) ||
                        node === event.target;
                })) {
                return;
            }
            if (onClickOutside) {
                onClickOutside(event);
            }
        };
        var onTouchStart = function (event) {
            onMouseDown(event);
            mouseTouches.current = event.touches.length;
        };
        var onTouchEnd = function (event) {
            mouseTouches.current = event.touches.length;
        };
        if (activeNode) {
            document.addEventListener('keydown', onKeyDown);
            document.addEventListener('mousedown', onMouseDown);
            document.addEventListener('touchstart', onTouchStart);
            document.addEventListener('touchend', onTouchEnd);
            return function () {
                document.removeEventListener('keydown', onKeyDown);
                document.removeEventListener('mousedown', onMouseDown);
                document.removeEventListener('touchstart', onTouchStart);
                document.removeEventListener('touchend', onTouchEnd);
            };
        }
    }, [activeNode, onClickOutside, onEscapeKey]);
    Object(react["useEffect"])(function () {
        if (activeNode) {
            if (onActivation) {
                onActivation(activeNode);
            }
            return function () {
                if (onDeactivation) {
                    onDeactivation();
                }
            };
        }
    }, [!!activeNode]);
    Object(react["useEffect"])(function () {
        var _undo = function () { return null; };
        var unmounted = false;
        var onNodeActivation = function (node) {
            _undo = hideOthers([node].concat((shards || []).map(Effect_extractRef)), document.body, noIsolation ? undefined : dist_es2015_medium["b" /* focusHiddenMarker */]);
            setActiveNode(function () { return node; });
        };
        var onNodeDeactivation = function () {
            _undo();
            if (!unmounted) {
                setActiveNode(null);
            }
        };
        setLockProps({
            onMouseDown: function (e) {
                lastEventTarget.current = e.target;
            },
            onTouchStart: function (e) {
                lastEventTarget.current = e.target;
            },
            onActivation: onNodeActivation,
            onDeactivation: onNodeDeactivation
        });
        return function () {
            unmounted = true;
            setLockProps(false);
        };
    }, []);
    return react["createElement"](InteractivityDisabler, null);
}

// CONCATENATED MODULE: /home/circleci/project/node_modules/react-focus-on/dist/es2015/sidecar.js





/* harmony default export */ var dist_es2015_sidecar = __webpack_exports__["default"] = (exportSidecar(dist_es2015_medium["a" /* effectCar */], Effect));


/***/ }),

/***/ "Ix1X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createMedium; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createSidecarMedium; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("D57K");

function ItoI(a) {
    return a;
}
function innerCreateMedium(defaults, middleware) {
    if (middleware === void 0) { middleware = ItoI; }
    var buffer = [];
    var assigned = false;
    var medium = {
        read: function () {
            if (assigned) {
                throw new Error('Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.');
            }
            if (buffer.length) {
                return buffer[buffer.length - 1];
            }
            return defaults;
        },
        useMedium: function (data) {
            var item = middleware(data, assigned);
            buffer.push(item);
            return function () {
                buffer = buffer.filter(function (x) { return x !== item; });
            };
        },
        assignSyncMedium: function (cb) {
            assigned = true;
            while (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
            }
            buffer = {
                push: function (x) { return cb(x); },
                filter: function () { return buffer; },
            };
        },
        assignMedium: function (cb) {
            assigned = true;
            var pendingQueue = [];
            if (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
                pendingQueue = buffer;
            }
            var executeQueue = function () {
                var cbs = pendingQueue;
                pendingQueue = [];
                cbs.forEach(cb);
            };
            var cycle = function () { return Promise.resolve().then(executeQueue); };
            cycle();
            buffer = {
                push: function (x) {
                    pendingQueue.push(x);
                    cycle();
                },
                filter: function (filter) {
                    pendingQueue = pendingQueue.filter(filter);
                    return buffer;
                },
            };
        },
    };
    return medium;
}
function createMedium(defaults, middleware) {
    if (middleware === void 0) { middleware = ItoI; }
    return innerCreateMedium(defaults, middleware);
}
function createSidecarMedium(options) {
    if (options === void 0) { options = {}; }
    var medium = innerCreateMedium(null);
    medium.options = tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"]({ async: true, ssr: false }, options);
    return medium;
}


/***/ }),

/***/ "MWZw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Title_Title; });

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /home/circleci/project/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /home/circleci/project/node_modules/classnames/index.js
var classnames = __webpack_require__("O94r");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// CONCATENATED MODULE: ./src/client/components/frameworks/title/Title.themes.js

var themes = {
  none: {
    thDefaultColor: 'current',
    thTitle: '',
    thIcon: ''
  },
  'title-brand-1': {
    thDefaultColor: colors["a" /* COLORS */].BLUE,
    thTitle: 'flex items-center justify-center font-brand font-normal leading-tight text-center text-xl md:text-2xl',
    thIcon: 'rtl:mr-2'
  },
  'title-brand-2': {
    thDefaultColor: colors["a" /* COLORS */].GRAY_DARKER,
    thTitle: 'flex items-center font-brand font-normal leading-tight text-xl lg:text-2xl',
    thIcon: 'rtl:mr-2'
  },
  'title-brand-3': {
    thDefaultColor: colors["a" /* COLORS */].BLUE,
    thTitle: 'flex items-center font-brand font-normal leading-tight text-lg',
    thIcon: 'rtl:mr-2'
  },
  'title-brand-4': {
    thDefaultColor: colors["a" /* COLORS */].GRAY_DARKER,
    thTitle: 'border-b-1 border-gray-light flex items-center justify-center font-brand font-normal leading-tight pb-2 text-lg',
    thIcon: 'rtl:mr-2'
  },
  'title-brand-5': {
    thDefaultColor: colors["a" /* COLORS */].BLUE,
    thTitle: 'border-b-1 border-gray-light flex items-center font-brand leading-tight pb-1 text-xl',
    thIcon: 'rtl:mr-2 mb-1'
  },
  'title-brand-6': {
    thDefaultColor: colors["a" /* COLORS */].BLUE,
    thTitle: 'border-b-1 border-current decorator-losange flex items-center justify-center font-brand font-normal leading-tight pb-2 text-3xl',
    thIcon: 'rtl:mr-2'
  },
  'title-brand-7': {
    thDefaultColor: colors["a" /* COLORS */].GRAY_DARKER,
    thTitle: 'flex items-center font-brand font-normal leading-tight text-xl',
    thIcon: 'rtl:mr-2'
  },
  'title-brand-9': {
    thDefaultColor: colors["a" /* COLORS */].BLUE,
    thTitle: 'text-center md:text-initial leading-tight text-xl font-brand font-normal',
    thIcon: 'rtl:mr-2'
  },
  'title-brand-10': {
    thDefaultColor: colors["a" /* COLORS */].GRAY_DARKER,
    thTitle: 'flex font-brand font-normal items-baseline leading-tight text-2xl sm:text-3xl text-initial',
    thIcon: 'self-center rtl:mr-2'
  },
  'title-brand-11': {
    thDefaultColor: colors["a" /* COLORS */].GRAY_DARKER,
    thTitle: 'flex font-brand font-normal items-baseline leading-tight text-xl sm:text-2xl text-initial',
    thIcon: 'self-center rtl:mr-2'
  },
  'title-sans-1': {
    thDefaultColor: colors["a" /* COLORS */].GRAY_DARKER,
    thTitle: 'flex items-center font-bold font-sans leading-normal text-base',
    thIcon: 'rtl:mr-1'
  },
  'title-sans-2': {
    thDefaultColor: colors["a" /* COLORS */].BLUE,
    thTitle: 'flex items-center font-bold font-sans leading-tight text-xl uppercase',
    thIcon: 'rtl:mr-2'
  },
  'title-sans-3': {
    thDefaultColor: colors["a" /* COLORS */].GRAY_DARKER,
    thTitle: 'flex items-center font-bold font-sans leading-tight text-md',
    thIcon: 'rtl:mr-1'
  },
  'title-sans-4': {
    thDefaultColor: colors["a" /* COLORS */].GRAY_DARKER,
    thTitle: 'flex items-center font-bold font-sans leading-tight text-xl',
    thIcon: 'rtl:mr-2'
  },
  'title-sans-8': {
    thDefaultColor: colors["a" /* COLORS */].BLUE,
    thTitle: 'flex items-center justify-center font-bold font-sans leading-tight text-3xl sm:text-5xl text-center',
    thIcon: 'rtl:mr-4'
  },
  'title-sans-9': {
    thDefaultColor: colors["a" /* COLORS */].GRAY_DARKER,
    thTitle: 'flex items-center font-bold font-sans leading-tight text-2xl',
    thIcon: 'rtl:mr-8'
  },
  'title-sans-10': {
    thDefaultColor: colors["a" /* COLORS */].GRAY_DARKER,
    thTitle: 'flex items-center font-bold font-sans leading-tight text-md',
    thIcon: 'rtl:mr-3'
  },
  'title-sans-11': {
    thDefaultColor: colors["a" /* COLORS */].GRAY_DARKER,
    thTitle: 'decorator-dash flex items-center font-normal font-sans leading-tight text-md',
    thIcon: 'rtl:mr-1'
  },
  'title-sans-12': {
    thDefaultColor: colors["a" /* COLORS */].GRAY_DARKER,
    thTitle: 'flex items-center font-bold font-sans leading-tight text-base',
    thIcon: 'rtl:mr-1'
  },
  'title-sans-13': {
    thDefaultColor: colors["a" /* COLORS */].BLUE,
    thTitle: 'flex items-center justify-center font-bold font-sans leading-tight text-xl sm:text-3xl text-center',
    thIcon: 'rtl:mr-4'
  },
  'title-serif-1': {
    thDefaultColor: colors["a" /* COLORS */].DEEP_BLUE,
    thTitle: 'flex items-center justify-center font-bold font-serif leading-tight text-2xl lg:text-4xl',
    thIcon: 'rtl:mr-1'
  },
  'title-serif-2': {
    thDefaultColor: colors["a" /* COLORS */].DEEP_BLUE,
    thTitle: 'flex items-center justify-center md:justify-start font-bold font-serif leading-tight text-2xl lg:text-4xl',
    thIcon: 'rtl:mr-1'
  },
  'title-serif-3': {
    thDefaultColor: colors["a" /* COLORS */].GRAY_DARKER,
    thTitle: 'flex items-center font-bold font-serif leading-tight text-md',
    thIcon: 'rtl:mr-1'
  },
  'title-serif-4': {
    thDefaultColor: colors["a" /* COLORS */].BLUE,
    thTitle: 'flex items-center font-bold font-serif leading-tight text-xl',
    thIcon: 'rtl:mr-1'
  },
  'title-serif-5': {
    thDefaultColor: colors["a" /* COLORS */].GRAY_DARKER,
    thTitle: 'flex font-serif font-bold items-baseline leading-tight text-2xl sm:text-3xl text-initial',
    thIcon: 'self-center rtl:mr-2'
  },
  'title-serif-7': {
    thDefaultColor: colors["a" /* COLORS */].DEEP_BLUE,
    thTitle: 'flex items-center justify-center font-serif font-normal leading-tight text-center text-xl md:text-2xl',
    thIcon: 'rtl:mr-2'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/title/Title.jsx

var __jsx = react_default.a.createElement;




var Title_Title = function Title(_ref) {
  var children = _ref.children,
      className = _ref.className,
      color = _ref.color,
      hasEllipsis = _ref.hasEllipsis,
      _ref$hLevel = _ref.hLevel,
      hLevel = _ref$hLevel === void 0 ? 2 : _ref$hLevel,
      iconColor = _ref.iconColor,
      iconName = _ref.iconName,
      iconSize = _ref.iconSize,
      id = _ref.id,
      role = _ref.role,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'title-brand-5' : _ref$theme;

  if (!children) {
    return null;
  }

  var _ref2 = themes[theme] || {},
      thDefaultColor = _ref2.thDefaultColor,
      thIcon = _ref2.thIcon,
      thIconSize = _ref2.thIconSize,
      thTitle = _ref2.thTitle; // prevent bad handwriting


  var TagName = "h".concat(hLevel);
  var textColor = color || thDefaultColor;
  var classes = classnames_default()(className, 'reset-heading', "text-".concat(textColor), thTitle);
  return __jsx(TagName, Object(esm_extends["a" /* default */])({
    className: classes,
    id: id
  }, role ? {
    role: role
  } : null), __jsx(Icon["a" /* Icon */], {
    className: classnames_default()(thIcon, 'flex-shrink-0'),
    color: iconColor,
    name: iconName,
    width: iconSize || thIconSize || '1em'
  }), hasEllipsis ? __jsx("span", {
    className: "truncate w-full"
  }, children) : children);
};

/***/ }),

/***/ "Oi45":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return zeroRightClassName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fullWidthClassName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return noScrollbarsClassName; });
var zeroRightClassName = 'right-scroll-bar-position';
var fullWidthClassName = 'width-before-scroll-bar';
var noScrollbarsClassName = 'with-scroll-bars-hidden';


/***/ }),

/***/ "Qt1m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Combination_FocusOn; });

// EXTERNAL MODULE: /home/circleci/project/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__("D57K");

// EXTERNAL MODULE: /home/circleci/project/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /home/circleci/project/node_modules/react-remove-scroll-bar/dist/es2015/constants.js
var constants = __webpack_require__("Oi45");

// EXTERNAL MODULE: /home/circleci/project/node_modules/react-remove-scroll/dist/es2015/medium.js
var medium = __webpack_require__("StW7");

// CONCATENATED MODULE: /home/circleci/project/node_modules/use-callback-ref/dist/es2015/useRef.js

function useCallbackRef(initialValue, callback) {
    var ref = Object(react["useState"])(function () { return ({
        value: initialValue,
        callback: callback,
        facade: {
            get current() {
                return ref.value;
            },
            set current(value) {
                var last = ref.value;
                if (last !== value) {
                    ref.value = value;
                    ref.callback(value, last);
                }
            }
        }
    }); })[0];
    ref.callback = callback;
    return ref.facade;
}

// CONCATENATED MODULE: /home/circleci/project/node_modules/use-callback-ref/dist/es2015/assignRef.js
function assignRef(ref, value) {
    if (typeof ref === 'function') {
        ref(value);
    }
    else if (ref != null) {
        ref.current = value;
    }
    return ref;
}

// CONCATENATED MODULE: /home/circleci/project/node_modules/use-callback-ref/dist/es2015/useMergeRef.js


function useMergeRefs(refs, defaultValue) {
    return useCallbackRef(defaultValue, function (newValue) {
        return refs.forEach(function (ref) { return assignRef(ref, newValue); });
    });
}

// CONCATENATED MODULE: /home/circleci/project/node_modules/react-remove-scroll/dist/es2015/UI.js





var nothing = function () {
    return;
};
var RemoveScroll = react["forwardRef"](function (props, parentRef) {
    var ref = react["useRef"](null);
    var _a = react["useState"]({
        onScrollCapture: nothing,
        onWheelCapture: nothing,
        onTouchMoveCapture: nothing
    }), callbacks = _a[0], setCallbacks = _a[1];
    var forwardProps = props.forwardProps, children = props.children, className = props.className, removeScrollBar = props.removeScrollBar, enabled = props.enabled, shards = props.shards, sideCar = props.sideCar, noIsolation = props.noIsolation, inert = props.inert, allowPinchZoom = props.allowPinchZoom, rest = tslib_es6["b" /* __rest */](props, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom"]);
    var SideCar = sideCar;
    var containerProps = tslib_es6["a" /* __assign */]({ ref: useMergeRefs([
            ref,
            parentRef
        ]) }, rest, callbacks);
    return (react["createElement"](react["Fragment"], null,
        enabled && (react["createElement"](SideCar, { sideCar: medium["a" /* effectCar */], removeScrollBar: removeScrollBar, shards: shards, noIsolation: noIsolation, inert: inert, setCallbacks: setCallbacks, allowPinchZoom: !!allowPinchZoom, lockRef: ref })),
        forwardProps ? (react["cloneElement"](react["Children"].only(children), containerProps)) : (react["createElement"]("div", tslib_es6["a" /* __assign */]({}, containerProps, { className: className }), children))));
});
RemoveScroll.defaultProps = {
    enabled: true,
    removeScrollBar: true,
    inert: false
};
RemoveScroll.classNames = {
    fullWidth: constants["a" /* fullWidthClassName */],
    zeroRight: constants["c" /* zeroRightClassName */]
};


// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /home/circleci/project/node_modules/prop-types/index.js
var prop_types = __webpack_require__("aWzz");

// EXTERNAL MODULE: /home/circleci/project/node_modules/focus-lock/dist/es2015/constants.js
var es2015_constants = __webpack_require__("R6jJ");

// CONCATENATED MODULE: /home/circleci/project/node_modules/react-focus-lock/dist/es2015/FocusGuard.js


var hiddenGuard = {
  width: '1px',
  height: '0px',
  padding: 0,
  overflow: 'hidden',
  position: 'fixed',
  top: '1px',
  left: '1px'
};

var FocusGuard_InFocusGuard = function InFocusGuard(_ref) {
  var children = _ref.children;
  return react_default.a.createElement(react_default.a.Fragment, null, react_default.a.createElement("div", {
    key: "guard-first",
    "data-focus-guard": true,
    "data-focus-auto-guard": true,
    style: hiddenGuard
  }), children, children && react_default.a.createElement("div", {
    key: "guard-last",
    "data-focus-guard": true,
    "data-focus-auto-guard": true,
    style: hiddenGuard
  }));
};

FocusGuard_InFocusGuard.propTypes =  false ? undefined : {};
FocusGuard_InFocusGuard.defaultProps = {
  children: null
};
/* harmony default export */ var FocusGuard = (FocusGuard_InFocusGuard);
// EXTERNAL MODULE: /home/circleci/project/node_modules/react-focus-lock/dist/es2015/medium.js
var es2015_medium = __webpack_require__("7LZv");

// CONCATENATED MODULE: /home/circleci/project/node_modules/react-focus-lock/dist/es2015/Lock.js







var emptyArray = [];
var FocusLock = react_default.a.forwardRef(function (props, parentRef) {
  var _extends2;

  var _useState = Object(react["useState"])(),
      realObserved = _useState[0],
      setObserved = _useState[1];

  var observed = Object(react["useRef"])();
  var isActive = Object(react["useRef"])(false);
  var originalFocusedElement = Object(react["useRef"])(null);
  var children = props.children,
      disabled = props.disabled,
      noFocusGuards = props.noFocusGuards,
      persistentFocus = props.persistentFocus,
      autoFocus = props.autoFocus,
      allowTextSelection = props.allowTextSelection,
      group = props.group,
      className = props.className,
      whiteList = props.whiteList,
      _props$shards = props.shards,
      shards = _props$shards === void 0 ? emptyArray : _props$shards,
      _props$as = props.as,
      Container = _props$as === void 0 ? 'div' : _props$as,
      _props$lockProps = props.lockProps,
      containerProps = _props$lockProps === void 0 ? {} : _props$lockProps,
      SideCar = props.sideCar,
      shouldReturnFocus = props.returnFocus,
      onActivationCallback = props.onActivation,
      onDeactivationCallback = props.onDeactivation;

  var _useState2 = Object(react["useState"])({}),
      id = _useState2[0]; // SIDE EFFECT CALLBACKS


  var onActivation = Object(react["useCallback"])(function () {
    originalFocusedElement.current = originalFocusedElement.current || document && document.activeElement;

    if (observed.current && onActivationCallback) {
      onActivationCallback(observed.current);
    }

    isActive.current = true;
  }, [onActivationCallback]);
  var onDeactivation = Object(react["useCallback"])(function () {
    isActive.current = false;

    if (onDeactivationCallback) {
      onDeactivationCallback(observed.current);
    }
  }, [onDeactivationCallback]);
  var returnFocus = Object(react["useCallback"])(function (allowDefer) {
    var current = originalFocusedElement.current;

    if (Boolean(shouldReturnFocus) && current && current.focus) {
      var focusOptions = typeof shouldReturnFocus === 'object' ? shouldReturnFocus : undefined;
      originalFocusedElement.current = null;

      if (allowDefer) {
        // React might return focus after update
        // it's safer to defer the action
        Promise.resolve().then(function () {
          return current.focus(focusOptions);
        });
      } else {
        current.focus(focusOptions);
      }
    }
  }, [shouldReturnFocus]); // MEDIUM CALLBACKS

  var onFocus = Object(react["useCallback"])(function (event) {
    if (isActive.current) {
      es2015_medium["c" /* mediumFocus */].useMedium(event);
    }
  }, []);
  var onBlur = es2015_medium["a" /* mediumBlur */].useMedium; // REF PROPAGATION
  // not using real refs due to race conditions

  var setObserveNode = Object(react["useCallback"])(function (newObserved) {
    if (observed.current !== newObserved) {
      observed.current = newObserved;
      setObserved(newObserved);
    }
  }, []);

  if (false) {}

  var lockProps = Object(esm_extends["a" /* default */])((_extends2 = {}, _extends2[es2015_constants["c" /* FOCUS_DISABLED */]] = disabled && 'disabled', _extends2[es2015_constants["d" /* FOCUS_GROUP */]] = group, _extends2), containerProps);

  var hasLeadingGuards = noFocusGuards !== true;
  var hasTailingGuards = hasLeadingGuards && noFocusGuards !== 'tail';
  var mergedRef = useMergeRefs([parentRef, setObserveNode]);
  return react_default.a.createElement(react_default.a.Fragment, null, hasLeadingGuards && [react_default.a.createElement("div", {
    key: "guard-first",
    "data-focus-guard": true,
    tabIndex: disabled ? -1 : 0,
    style: hiddenGuard
  }), // nearest focus guard
  react_default.a.createElement("div", {
    key: "guard-nearest",
    "data-focus-guard": true,
    tabIndex: disabled ? -1 : 1,
    style: hiddenGuard
  })], !disabled && react_default.a.createElement(SideCar, {
    id: id,
    sideCar: es2015_medium["d" /* mediumSidecar */],
    observed: realObserved,
    disabled: disabled,
    persistentFocus: persistentFocus,
    autoFocus: autoFocus,
    whiteList: whiteList,
    shards: shards,
    onActivation: onActivation,
    onDeactivation: onDeactivation,
    returnFocus: returnFocus
  }), react_default.a.createElement(Container, Object(esm_extends["a" /* default */])({
    ref: mergedRef
  }, lockProps, {
    className: className,
    onBlur: onBlur,
    onFocus: onFocus
  }), children), hasTailingGuards && react_default.a.createElement("div", {
    "data-focus-guard": true,
    tabIndex: disabled ? -1 : 0,
    style: hiddenGuard
  }));
});
FocusLock.propTypes =  false ? undefined : {};
FocusLock.defaultProps = {
  children: undefined,
  disabled: false,
  returnFocus: false,
  noFocusGuards: false,
  autoFocus: true,
  persistentFocus: false,
  allowTextSelection: undefined,
  group: undefined,
  className: undefined,
  whiteList: undefined,
  shards: undefined,
  as: 'div',
  lockProps: {},
  onActivation: undefined,
  onDeactivation: undefined
};
/* harmony default export */ var Lock = (FocusLock);
// CONCATENATED MODULE: /home/circleci/project/node_modules/react-focus-lock/dist/es2015/UI.js






/* harmony default export */ var UI = (Lock);
// EXTERNAL MODULE: /home/circleci/project/node_modules/react-focus-on/dist/es2015/medium.js
var dist_es2015_medium = __webpack_require__("ZLQb");

// CONCATENATED MODULE: /home/circleci/project/node_modules/react-focus-on/dist/es2015/UI.js





var FocusOn = react["forwardRef"](function (props, parentRef) {
    var _a = react["useState"](false), lockProps = _a[0], setLockProps = _a[1];
    var children = props.children, autoFocus = props.autoFocus, shards = props.shards, _b = props.enabled, enabled = _b === void 0 ? true : _b, _c = props.scrollLock, scrollLock = _c === void 0 ? true : _c, _d = props.focusLock, focusLock = _d === void 0 ? true : _d, _e = props.returnFocus, returnFocus = _e === void 0 ? true : _e, inert = props.inert, allowPinchZoom = props.allowPinchZoom, sideCar = props.sideCar, className = props.className, rest = tslib_es6["b" /* __rest */](props, ["children", "autoFocus", "shards", "enabled", "scrollLock", "focusLock", "returnFocus", "inert", "allowPinchZoom", "sideCar", "className"]);
    var SideCar = sideCar;
    var onActivation = lockProps.onActivation, onDeactivation = lockProps.onDeactivation, restProps = tslib_es6["b" /* __rest */](lockProps, ["onActivation", "onDeactivation"]);
    return (react["createElement"](react["Fragment"], null,
        react["createElement"](UI, { ref: parentRef, sideCar: sideCar, disabled: !(lockProps && enabled && focusLock), returnFocus: returnFocus, autoFocus: autoFocus, shards: shards, onActivation: onActivation, onDeactivation: onDeactivation, className: className, as: RemoveScroll, lockProps: tslib_es6["a" /* __assign */]({}, restProps, { sideCar: sideCar,
                shards: shards,
                allowPinchZoom: allowPinchZoom,
                inert: inert, enabled: enabled && scrollLock }) }, children),
        enabled && (react["createElement"](SideCar, tslib_es6["a" /* __assign */]({}, rest, { sideCar: dist_es2015_medium["a" /* effectCar */], setLockProps: setLockProps, shards: shards })))));
});


// CONCATENATED MODULE: /home/circleci/project/node_modules/react-focus-on/dist/es2015/Combination.js



var RequireSideCar = function (props) {
    // @ts-ignore
    var SideCar = __webpack_require__("Foxp").default;
    return react["createElement"](SideCar, tslib_es6["a" /* __assign */]({}, props));
};
var Combination_FocusOn = react["forwardRef"](function (props, ref) { return react["createElement"](FocusOn, tslib_es6["a" /* __assign */]({}, props, { ref: ref, sideCar: RequireSideCar })); });


/***/ }),

/***/ "R6jJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FOCUS_GROUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FOCUS_DISABLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FOCUS_ALLOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FOCUS_AUTO; });
var FOCUS_GROUP = 'data-focus-lock';
var FOCUS_DISABLED = 'data-focus-lock-disabled';
var FOCUS_ALLOW = 'data-no-focus-lock';
var FOCUS_AUTO = 'data-autofocus-inside';

/***/ }),

/***/ "StW7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return effectCar; });
/* harmony import */ var use_sidecar__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("Ix1X");

var effectCar = Object(use_sidecar__WEBPACK_IMPORTED_MODULE_0__[/* createSidecarMedium */ "b"])();


/***/ }),

/***/ "Yd/I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACCESSIBLE_TITLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return BEFORE_APP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AFTER_APP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return OVER_BOT; });
var ACCESSIBLE_TITLE = 'clubmed-accessible-title';
var BEFORE_APP = 'clubmed-portal-before';
var AFTER_APP = 'clubmed-portal-after';
var OVER_BOT = 'clubmed-portal-over';

/***/ }),

/***/ "ZLQb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return effectCar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return focusHiddenMarker; });
/* harmony import */ var use_sidecar__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("Ix1X");

var effectCar = Object(use_sidecar__WEBPACK_IMPORTED_MODULE_0__[/* createSidecarMedium */ "b"])();
var focusHiddenMarker = 'data-focus-on-hidden';


/***/ }),

/***/ "qVkC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getTopScrollValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return lockBodyScroll; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return resumeBodyScroll; });
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);
/* eslint-env browser */


function getTopScrollValue(document) {
  return Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(document, 'documentElement.scrollTop') ? Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(document, 'documentElement.scrollTop') : Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(document, 'body.scrollTop', 0);
}

var instances = 0;

function lockBodyScroll(document) {
  var body = Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(document, 'body', {});

  if (body) {
    ++instances; // We add a "z-index: 0" on body to better handle portals on IE11

    body.setAttribute('style', "overflow: hidden; position:fixed !important; top: -".concat(getTopScrollValue(document), "px;width: 100%;z-index:0;"));
  }
}

function resumeBodyScroll(document, previousPosition) {
  var body = Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(document, 'body', {});

  if (body && --instances === 0) {
    body.setAttribute('style', '');

    if (previousPosition !== 0) {
      body.scrollTop = previousPosition;
    }
  }

  if (document.documentElement) {
    if (previousPosition !== 0) {
      document.documentElement.scrollTop = previousPosition;
    }
  }
}



/***/ }),

/***/ "s5tn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return deferAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return inlineProp; });
function deferAction(action) {
  // Hidding setImmediate from Webpack to avoid inserting polyfill
  var _window = window,
      setImmediate = _window.setImmediate;

  if (typeof setImmediate !== 'undefined') {
    setImmediate(action);
  } else {
    setTimeout(action, 1);
  }
}
var inlineProp = function inlineProp(name, value) {
  var obj = {};
  obj[name] = value;
  return obj;
};

/***/ })

}]);